﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { VeilederUtstyrsstipendAppState } from '../Store/index';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';
import { connect } from 'react-redux';

import { toggleUtbetaling, toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';

import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface EResultOwnProps {
    tittelStipend: JSX.Element | null;
    idBa?: string;
    idBb?: string;
    //  resultat: number;
    verdi?: string;
    tekst: JSX.Element | null;
    utbrettLenke: JSX.Element | null;
    // utbetaling: Utbetaling;
    eventId: string | null;
}

type EResultatProps = MapStateToProps & MapDispatchToProps & EResultOwnProps;

class ResultatComponent extends React.PureComponent<EResultatProps> {
    utbetalingRef = React.createRef<HTMLDivElement>();

    constructor(props: EResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onVisUtbetalingClicked = this.onVisUtbetalingClicked.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onVisUtbetalingClicked(event: React.MouseEvent): void {
        this.props.toggleUtbetaling();
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { tittelStipend, verdi, tekst, utbrettLenke, visUtbetaling, visVilkar, epiContext, eventId } = this.props;
        //   const { locale } = this.props.epiContext;

        return (
            <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">{tittelStipend}</h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                        <div className="c-veileder__resultat-tekst">
                            <span>{verdi}</span>
                            <span className="c-veileder__tekst c-veileder__tekst--postfix">&nbsp;{epiContext.valuta}</span>
                        </div>
                        <p className="c-veileder__tekst c-veileder__tekst--tett">{tekst}</p>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--with-double-space-mobile">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'modalLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'modalVilkarAriaLabel')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalVilkarTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalVilkarContent', 2)}
                            />
                        </ModalCompontent>
                    </div>
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--footer c-veileder__content--indented">
                        <button
                            type="button"
                            className={`c-knapp c-knapp--lenke c-knapp--fullwidth-ms c-knapp--centered c-knapp--icon-after c-knapp--pil-opp-hvit ${
                                visUtbetaling ? 'c-knapp--icon-reversed' : ''
                            }`}
                            onClick={this.onVisUtbetalingClicked}
                        >
                            {utbrettLenke}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederUtstyrsstipendDto>;
    visUtbetaling: boolean;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleUtbetaling: typeof toggleUtbetaling;
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederUtstyrsstipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visUtbetaling: state.valg.visUtbetaling,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleUtbetaling, toggleVilkar, updateZIndex },
)(ResultatComponent);
